"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    // TODO: remove these empty namespace once other dependent files have been converted
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
    $dyn.React = $dyn.DynReact;
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (beginning) {
            return this.substring(0, beginning.length) === beginning;
        };
    }
    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (ending) {
            return this.indexOf(ending, this.length - ending.length) !== -1;
        };
    }
    if (!HTMLElement.prototype.remove) {
        HTMLElement.prototype.remove = function () {
            // Polyfill the DOM4 remove method.
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }
    var util;
    (function (util) {
        util.dataAreaId = "dataAreaId";
        /**
         * Describes vertical element visibility relative to some container element.
         * @description Values of enum can be used as values of qtip position.my and position.at (Instead of 'partial')
         */
        var VerticalElementVisibility;
        (function (VerticalElementVisibility) {
            /** Completely contained in container */
            VerticalElementVisibility["VISIBLE"] = "center";
            /** Partially contained in container (rectangles intersect) */
            VerticalElementVisibility["PARTIAL"] = "partial";
            /** Completely above container */
            VerticalElementVisibility["INVISIBLE_TOP"] = "top";
            /** Completely below container */
            VerticalElementVisibility["INVISIBLE_BOTTOM"] = "bottom";
        })(VerticalElementVisibility = util.VerticalElementVisibility || (util.VerticalElementVisibility = {}));
        /**
         * Describes horizontal element visibility relative to some container element.
         * @description Values of enum can be used as values of qtip position.my and position.at (Instead of 'partial')
         */
        var HorizontalElementVisibility;
        (function (HorizontalElementVisibility) {
            /** Completely contained in container */
            HorizontalElementVisibility["VISIBLE"] = "center";
            /** Partially contained in container (rectangles intersect) */
            HorizontalElementVisibility["PARTIAL"] = "partial";
            /** Completely left of container */
            HorizontalElementVisibility["INVISIBLE_LEFT"] = "left";
            /** Completely right of container */
            HorizontalElementVisibility["INVISIBLE_RIGHT"] = "right";
        })(HorizontalElementVisibility = util.HorizontalElementVisibility || (util.HorizontalElementVisibility = {}));
        var timeSeparators;
        (function (timeSeparators) {
            timeSeparators["colon"] = ":";
            timeSeparators["dot"] = ".";
            timeSeparators["space"] = " ";
            timeSeparators["comma"] = ",";
            timeSeparators["slash"] = "/";
        })(timeSeparators = util.timeSeparators || (util.timeSeparators = {}));
        (function (timeSeparators) {
            timeSeparators.auto = Globalize.culture().calendar[":"] ? Globalize.culture().calendar[":"] : timeSeparators.space;
        })(timeSeparators = util.timeSeparators || (util.timeSeparators = {}));
        var TimeZonePreference;
        (function (TimeZonePreference) {
            /** Equivalent to 'User' */
            TimeZonePreference["auto"] = "Auto";
            /** Date/time values displayed by the control should have the user's preferred time zone applied */
            TimeZonePreference["user"] = "User";
            /** Date/time values displayed by the control should NOT have any time zone applied */
            TimeZonePreference["none"] = "NoConversion";
        })(TimeZonePreference = util.TimeZonePreference || (util.TimeZonePreference = {}));
        // tslint:disable-next-line:variable-name
        util._performancePolyfill = {};
        if (!window.performance) {
            // Safari does not have the performance object
            window.performance = {};
            if (!performance.now) {
                performance.now = function () {
                    return Date.now();
                };
            }
            if (!performance.mark) {
                performance.mark = function (name) {
                    if (!$dyn.util._performancePolyfill[name]) {
                        $dyn.util._performancePolyfill[name] = [];
                    }
                    $dyn.util._performancePolyfill[name].push({
                        duration: 0,
                        entryType: "mark",
                        name: name,
                        startTime: performance.now(),
                        toJSON: function () { },
                    });
                };
            }
            if (!performance.getEntriesByName) {
                performance.getEntriesByName = function (name) {
                    return $dyn.util._performancePolyfill[name];
                };
            }
        }
        /**
         * Retrieve the vertical element visibility relative to the container element.
         */
        function elementVerticalVisibilityInParentContainer(elementRect, parentRect) {
            if (!elementRect || !parentRect) {
                return null;
            }
            var elementTop = elementRect.top;
            var elementBottom = elementRect.bottom;
            var parentTop = parentRect.top;
            var parentBottom = parentRect.bottom;
            if (elementTop >= parentTop && elementBottom <= parentBottom) {
                return $dyn.util.VerticalElementVisibility.VISIBLE;
            }
            if (elementBottom < parentTop) {
                return $dyn.util.VerticalElementVisibility.INVISIBLE_TOP;
            }
            if (elementTop > parentBottom) {
                return $dyn.util.VerticalElementVisibility.INVISIBLE_BOTTOM;
            }
            return $dyn.util.VerticalElementVisibility.PARTIAL;
        }
        util.elementVerticalVisibilityInParentContainer = elementVerticalVisibilityInParentContainer;
        /**
         * Retrieve the horizontal element visibility relative to the container element.
         */
        function elementHorizontalVisibilityInParentContainer(elementRect, parentRect) {
            // Can be refactored to segment intersection concept
            if (!elementRect || !parentRect) {
                return null;
            }
            var elementLeft = elementRect.left;
            var elementRight = elementRect.right;
            var parentLeft = parentRect.left;
            var parentRight = parentRect.right;
            if (elementLeft >= parentLeft && elementRight <= parentRight) {
                return $dyn.util.HorizontalElementVisibility.VISIBLE;
            }
            if (elementRight < parentLeft) {
                return $dyn.util.HorizontalElementVisibility.INVISIBLE_LEFT;
            }
            if (elementLeft > parentRight) {
                return $dyn.util.HorizontalElementVisibility.INVISIBLE_RIGHT;
            }
            return $dyn.util.HorizontalElementVisibility.PARTIAL;
        }
        util.elementHorizontalVisibilityInParentContainer = elementHorizontalVisibilityInParentContainer;
        /**
         * Retrieve the element visibility relative to the container element.
         */
        function isElementVisibleInParentContainer(currentElementRect, parentElementRect) {
            var horizontalVisibility = $dyn.util.elementHorizontalVisibilityInParentContainer(currentElementRect, parentElementRect);
            var verticalVisibility = $dyn.util.elementVerticalVisibilityInParentContainer(currentElementRect, parentElementRect);
            if (horizontalVisibility === $dyn.util.HorizontalElementVisibility.INVISIBLE_LEFT || horizontalVisibility === $dyn.util.HorizontalElementVisibility.INVISIBLE_RIGHT ||
                verticalVisibility === $dyn.util.VerticalElementVisibility.INVISIBLE_TOP || verticalVisibility === $dyn.util.VerticalElementVisibility.INVISIBLE_BOTTOM) {
                return false;
            }
            return true;
        }
        util.isElementVisibleInParentContainer = isElementVisibleInParentContainer;
        /**
         * Converts a jQuery object to a simpler object.
         * @param $element A jQuery object referencing the targeted DOM object.
         */
        function elementRectangle($element) {
            if ($element && $element.offset) {
                var offset = $element.offset();
                if (offset) {
                    var top_1 = offset.top;
                    var bottom = top_1 + $element[0].offsetHeight;
                    var left = offset.left;
                    var right = left + $element[0].offsetWidth;
                    return { top: top_1, bottom: bottom, left: left, right: right };
                }
            }
        }
        util.elementRectangle = elementRectangle;
        /**
         * Checks if mutation observers are supported.
         * @description MutationObservers are no supported in IE 10 and older browsers.
         */
        function mutationObserverSupported() {
            return window && window.MutationObserver ? true : false;
        }
        util.mutationObserverSupported = mutationObserverSupported;
        /**
         * Determines what function to be used to resolve paths.
         * @param rootPath The root path of the url.
         */
        function getPathResolver(rootPath) {
            var regExp = new RegExp("^\/namespaces\/", "i");
            if (regExp.test(rootPath)) {
                rootPath = rootPath.endsWith("/") ? rootPath.slice(0, -1) : rootPath;
                rootPath = rootPath.endsWith(".htm") ? rootPath.substring(0, rootPath.lastIndexOf("/")) : rootPath;
                return function (url) {
                    if (url && url.startsWith && url.startsWith("/") && !url.startsWith(rootPath)) {
                        return rootPath + url;
                    }
                    else {
                        return url;
                    }
                };
            }
            else {
                return function (url) { return url; };
            }
        }
        util.getPathResolver = getPathResolver;
        /**
         * Appends the base URL path (if any) to absolute paths.
         */
        util.resolveVirtualPath = (function () {
            var rootPath = window.location.pathname;
            return $dyn.util.getPathResolver(rootPath);
        })();
        /**
         * Parses a url into its parts scheme (i.e. protocol), authority (i.e. domain name), path, query string, and fragment (i.e. #hash).
         */
        function parseUrl(url) {
            var builder = new $dyn.util.UrlBuilder();
            builder.parseUrl(url);
            return builder;
        }
        util.parseUrl = parseUrl;
        (function (parseUrl) {
            /** The regular expression for parsing urls is defined in RFC 3986. */
            // tslint:disable-next-line:variable-name
            parseUrl._queryStringRegExp = new RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
            /**
             * Decodes a url encoded component.
             * @param urlEncodedComponent The encoded url component
             */
            function _decode(urlEncodedComponent) {
                // TODO: Consider if decoding + (plus is an encoded space) is desired here.
                return decodeURIComponent(urlEncodedComponent);
            }
            parseUrl._decode = _decode;
        })(parseUrl = util.parseUrl || (util.parseUrl = {}));
        function pathCombine(baseUrl, combineWithUrl) {
            if (!baseUrl.endsWith("/")) {
                return baseUrl + "/" + combineWithUrl;
            }
            else {
                return baseUrl + combineWithUrl;
            }
        }
        util.pathCombine = pathCombine;
        function isLocation(obj) {
            return obj && obj.href ? true : false;
        }
        util.isLocation = isLocation;
        var UrlBuilder = /** @class */ (function () {
            function UrlBuilder() {
            }
            UrlBuilder.prototype.parseUrl = function (url) {
                var urlAsString;
                if (isLocation(url)) {
                    this.location = url;
                    urlAsString = url.href;
                }
                else {
                    urlAsString = url;
                }
                urlAsString = $dyn.util.resolveVirtualPath(urlAsString);
                var segments = $dyn.util.parseUrl._queryStringRegExp.exec(urlAsString);
                this.url = urlAsString;
                if (segments) {
                    this.scheme = segments[2] || "";
                    this.authority = segments[4] || "";
                    this.path = this.dir = segments[5] || "";
                    this.queryString = segments[7] || "";
                    this.fragment = segments[9] || "";
                }
                this.isRelative = !this.path.startsWith("/");
                this.pathSegments = this.dirSegments = this.path.split("/") || [];
                this.fileName = this.pathSegments[this.pathSegments.length - 1] || "";
                var extIndex = this.fileName.lastIndexOf(".");
                if (extIndex !== -1) {
                    this.dirSegments = this.pathSegments.slice(0);
                    this.dirSegments.pop();
                    this.dir = this.dirSegments.join("/");
                    this.fileExt = this.fileName.substring(extIndex + 1);
                    this.fileNameWithoutExt = this.fileName.substring(0, extIndex);
                }
                else {
                    this.fileName = "";
                }
                this.dir = this.dir.length > 0 && !this.dir.endsWith("/") ? this.dir + "/" : this.dir;
                this.query = $dyn.util.parseQueryString(this.queryString);
            };
            UrlBuilder.prototype.fromLocation = function (location) {
                this.location = location;
                this.url = location.href;
                this.parseUrl(this.url);
                this.host = location.hostname;
                this.port = location.port;
            };
            UrlBuilder.prototype.absoluteUrl = function () {
                var url = this.scheme + "://";
                if (this.host) {
                    url += this.host;
                    if (!this.isDefaultPort()) {
                        url += ":" + this.port;
                    }
                }
                else {
                    url += this.authority;
                }
                var pathAndQuery = this.relativeUrl(this);
                url += pathAndQuery;
                return url;
            };
            UrlBuilder.prototype.relativeTo = function (urlBuilder) {
                var url;
                if (this.authority) {
                    // Already is an absolute url
                    url = this.url;
                }
                else if (this.isRelative) {
                    var i = 0;
                    while (this.dirSegments[i] === "..") {
                        i++;
                    }
                    var dir = urlBuilder.dirSegments.slice(0, urlBuilder.dirSegments.length - i).join("/");
                    var path = this.pathSegments.slice(i).join("/");
                    url = $dyn.util.pathCombine(dir, path);
                }
                else {
                    url = this.path;
                }
                return url;
            };
            UrlBuilder.prototype.relativeUrl = function (urlBuilder) {
                if (!urlBuilder) {
                    urlBuilder = this;
                }
                var url = urlBuilder.path;
                if (urlBuilder.query) {
                    var first = true;
                    url += "?";
                    // tslint:disable-next-line: forin
                    for (var querykey in urlBuilder.query) {
                        if (!first) {
                            url += "&";
                        }
                        first = false;
                        if (querykey !== "") {
                            url += encodeURIComponent(querykey);
                            var queryValue = urlBuilder.query[querykey];
                            if (queryValue !== undefined && queryValue !== null) {
                                url += "=" + encodeURIComponent(queryValue);
                            }
                        }
                    }
                }
                return url;
            };
            UrlBuilder.prototype.isDefaultPort = function () {
                return !this.port || (this.scheme === "http" && this.port === "80") || (this.scheme === "https" && this.port === "443");
            };
            return UrlBuilder;
        }());
        util.UrlBuilder = UrlBuilder;
        /**
         * Parses a url query string into key/value pairs.
         * @description Creates a dictionary of the keys and their values. Values can also be retrieved using the lowercase key
         * @param queryString The query string to parse.
         */
        function parseQueryString(queryString) {
            var e_1, _a;
            if (!queryString) {
                return {};
            }
            var qmarkPos = queryString.indexOf("?") + 1;
            var pairs = queryString.substring(qmarkPos).split("&");
            var query = {};
            try {
                for (var pairs_1 = __values(pairs), pairs_1_1 = pairs_1.next(); !pairs_1_1.done; pairs_1_1 = pairs_1.next()) {
                    var pair = pairs_1_1.value;
                    var pairArray = pair.split("=");
                    if (pairArray.length >= 1) {
                        var key = $dyn.util.parseUrl._decode(pairArray[0]);
                        var lowerCaseKey = key.toLowerCase();
                        switch (pairArray.length) {
                            case 1:
                                query[key] = undefined;
                                break;
                            case 2:
                                query[key] = $dyn.util.parseUrl._decode(pairArray[1]);
                                break;
                        }
                        // If the key is not all lower case, include its lower case version in the query object,
                        // by default it's excluded from property enumeration so it's not added during query-building
                        if (key !== lowerCaseKey) {
                            (function (enteredKey, lowerKey) {
                                Object.defineProperty(query, lowerKey, {
                                    configurable: true,
                                    get: function () { return this[enteredKey]; },
                                    set: function (newValue) { this[enteredKey] = newValue; },
                                });
                            })(key, lowerCaseKey);
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (pairs_1_1 && !pairs_1_1.done && (_a = pairs_1.return)) _a.call(pairs_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return query;
        }
        util.parseQueryString = parseQueryString;
        util.relativeUrl = $dyn.util.UrlBuilder.prototype.relativeUrl;
        function scriptUrl(appRelativePath) {
            return $dyn.url(appRelativePath);
        }
        util.scriptUrl = scriptUrl;
        function htmlUrl(appRelativePath) {
            return $dyn.url(appRelativePath);
        }
        util.htmlUrl = htmlUrl;
        function styleSheetUrl(appRelativePath) {
            return $dyn.url(appRelativePath);
        }
        util.styleSheetUrl = styleSheetUrl;
        function imagesUrl(appRelativePath) {
            return $dyn.url(appRelativePath);
        }
        util.imagesUrl = imagesUrl;
        function fullHost() {
            if (window.location.pathname && window.location.pathname !== "/") {
                var pathSegments = window.location.pathname.split("/");
                if (pathSegments[1] === "namespaces") {
                    return window.location.host + "/" + pathSegments[1] + "/" + pathSegments[2];
                }
            }
            return window.location.host;
        }
        util.fullHost = fullHost;
        /**
         * IE can sometimes have origin be undefined. Construct it manually from the protocol, hostname and port.
         */
        function getOrigin(location) {
            var origin = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
            return origin;
        }
        util.getOrigin = getOrigin;
        /**
         * Checks if a end point is reachable.
         */
        function internetReachable() {
            function internetRestrictionsDetermined(restricted) {
                var restrictedInternetClass = "internetRestrictedOn";
                var bodyClassList = document.getElementsByTagName("body")[0].classList;
                $dyn.shell.hasRestrictedInternet(restricted);
                if (restricted) {
                    bodyClassList.add(restrictedInternetClass);
                }
                else {
                    bodyClassList.remove(restrictedInternetClass);
                }
                // now build the help menu , this is unique menu dependent on internet access
                $dyn.shell.buildHelpMenu();
            }
            $.when($dyn.deferred.onTrue(function () {
                var user = $dyn.value($dyn.user);
                return !!user && $dyn.value(user.ClientConnectivityEnabled) !== null;
            })).done(function () {
                if ($dyn.value($dyn.value($dyn.user).ClientConnectivityEnabled)) {
                    var request_1 = new XMLHttpRequest();
                    request_1.open("GET", ($dyn.appConfig && $dyn.appConfig.internetCheckURL) || $dyn.skypeInteraction.Constants.ProdOrigin, true);
                    request_1.onreadystatechange = function () {
                        if (request_1.readyState === 4) {
                            internetRestrictionsDetermined(!(request_1.status >= 200 && request_1.status < 304));
                        }
                    };
                    request_1.send();
                }
                else {
                    internetRestrictionsDetermined(true);
                }
            });
        }
        util.internetReachable = internetReachable;
        /**
         * Checks if HTML5 history functions are supported.
         * @description Some older browsers have defined HTML5 history functions, but they are buggy and do not function.
         * Tests if they can be used to confirm the browser is supported.
         * HTML5 history support is needed for $dyn.shell to function correctly.
         */
        function historySupported() {
            var supported = false;
            if (history.state) {
                supported = true;
            }
            else {
                window.history.replaceState({ test: 1 }, null, null);
                if (history.state && history.state.test) {
                    supported = true;
                    // remove the test state
                    window.history.replaceState(null, null, null);
                }
            }
            return supported;
        }
        util.historySupported = historySupported;
        /**
         * Checks if this is running on IE 10.
         * @description We are specifically not supporting IE 10.
         */
        function isIE10() {
            if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
                return true;
            }
            return false;
        }
        util.isIE10 = isIE10;
        /**
         * Check if local storage is supported.
         */
        function localStorageSupported() {
            // return early if already verified
            if ($dyn.util._localStorageSupported !== undefined) {
                return $dyn.util._localStorageSupported;
            }
            try {
                // best option is to read and write the value
                if (window.localStorage) {
                    localStorage.setItem("testkey", "1");
                    localStorage.getItem("testkey");
                    localStorage.removeItem("testkey");
                    $dyn.util._localStorageSupported = true;
                    return true;
                }
                else {
                    $dyn.util._localStorageSupported = false;
                    return false;
                }
            }
            catch (e) {
                $dyn.util.localStorageErorrHandler(e.name);
                $dyn.util._localStorageSupported = false;
                return false;
            }
        }
        util.localStorageSupported = localStorageSupported;
        /**
         * Handler for Local Storage save exceptions
         */
        function localStorageErorrHandler(errorName) {
            if (errorName === "QuotaExceededError" ||
                errorName === "NS_ERROR_DOM_QUOTA_REACHED") {
                $dyn.logError($dyn.label("Framework_LocalStorageQuotaError"));
            }
            else {
                $dyn.logError($dyn.label("Framework_LocalStorage") + ": %s", errorName);
            }
        }
        util.localStorageErorrHandler = localStorageErorrHandler;
        /**
         * Gets the current value of a flighted configuration option
         * @param flightName Name of the flight to fetch
         * @returns Value of the flight or undefined if it does not exist
         */
        function getFlightValue(flightName) {
            var user = $dyn.value($dyn.user);
            if (user && $dyn.value(user.FlightingFlags)) {
                return $dyn.user().FlightingFlags()[flightName];
            }
            return undefined;
        }
        util.getFlightValue = getFlightValue;
        /**
         * Retrieve the array index of an AX field based on the field ID.
         * @description AX extended field IDs contain an array index in their upper 16 bit.
         */
        function getAxArrayFieldIndex(axFieldId) {
            // tslint:disable-next-line:no-bitwise
            return (axFieldId & 0xff0000) >> 16;
        }
        util.getAxArrayFieldIndex = getAxArrayFieldIndex;
        function getBuildString() {
            var buildString = "";
            // are we setting a static value
            if ($dyn.flags.staticGenerators) {
                return "test build";
            }
            // first append build information
            if ($dyn.user() && $dyn.user().AppVersion && $dyn.user().AppVersion()) {
                var appVer = $dyn.user().AppVersion().split(": ", 2)[1];
                buildString = appVer ? appVer : "";
            }
            if ($dyn.user() && $dyn.user().PlatformVersion && $dyn.user().PlatformVersion()) {
                buildString += " : " + $dyn.user().PlatformVersion();
            }
            buildString += buildString ? " : " + $dyn.version.fullVerString : $dyn.version.fullVerString;
            return buildString;
        }
        util.getBuildString = getBuildString;
        /**
         * returns true if this is a preview build
         */
        function isPreviewBuild() {
            if ($dyn.user && $dyn.user().ProductIsPreview) {
                return $dyn.value($dyn.user().ProductIsPreview());
            }
            return false;
        }
        util.isPreviewBuild = isPreviewBuild;
        /**
         * Checks to see if EnhancedTabSequence is Enabled
         */
        function isEnhancedTabSequenceEnabled() {
            var enhancedTabSequenceEnabled = false;
            if (($dyn.peek($dyn.user) && $dyn.peek($dyn.peek($dyn.user).EnhancedTabSequence))) {
                enhancedTabSequenceEnabled = true;
            }
            return enhancedTabSequenceEnabled;
        }
        util.isEnhancedTabSequenceEnabled = isEnhancedTabSequenceEnabled;
        /**
         * Checks to see if TooltipOnFocus is Enabled
         */
        function isTooltipOnFocusEnabled() {
            var tooltipOnFocusEnabled = false;
            if (($dyn.peek($dyn.user) && $dyn.peek($dyn.peek($dyn.user).TooltipOnFocus))) {
                tooltipOnFocusEnabled = true;
            }
            else if ($dyn.flags.enableFocusTooltip) {
                tooltipOnFocusEnabled = true;
            }
            return tooltipOnFocusEnabled;
        }
        util.isTooltipOnFocusEnabled = isTooltipOnFocusEnabled;
        function isFlightEnabled(flightName) {
            var user = $dyn.value($dyn.user);
            if (user && $dyn.value(user.FlightingFlags)) {
                return $dyn.user().FlightingFlags()[flightName] ? true : false;
            }
            return false;
        }
        util.isFlightEnabled = isFlightEnabled;
        var HtmlNodeType;
        (function (HtmlNodeType) {
            HtmlNodeType[HtmlNodeType["text"] = 3] = "text";
        })(HtmlNodeType = util.HtmlNodeType || (util.HtmlNodeType = {}));
        var converters;
        (function (converters) {
            function boolean(val) {
                // truthy conversion of the value.
                // Examples of boolean attributes in html dom (disabled/hidden)
                return !!val;
            }
            converters.boolean = boolean;
            function booleanString(val) {
                if (typeof val === "boolean") {
                    return val;
                }
                if (val === null || val === undefined) {
                    return false;
                }
                val = val.toString().toLowerCase();
                return (val === "true" || val === "1" || val === "yes") ? true : false;
            }
            converters.booleanString = booleanString;
            function string(val) {
                if (typeof val === "string") {
                    return val;
                }
                else {
                    return val === null || val === undefined ? null : val.toString();
                }
            }
            converters.string = string;
            function notNullString(val) {
                return val === null || val === undefined ? "" : val.toString();
            }
            converters.notNullString = notNullString;
            function number(val, oldValue, defaultValue) {
                // When a number is non-number the default value is used.
                if (typeof val === "number") {
                    return val;
                }
                else {
                    return defaultValue;
                }
            }
            converters.number = number;
            function toObject(val) {
                return val;
            }
            converters.toObject = toObject;
        })(converters = util.converters || (util.converters = {}));
        util.stringToBoolean = $dyn.util.converters.booleanString;
        /**
         * Gets the enum names for an enum.
         */
        function enumNames(enumType) {
            if (enumType._enumNames) {
                return enumType._enumNames;
            }
            enumType._enumNames = { _enum: enumType };
            for (var item in enumType) {
                // Exclude private members
                if (item[0] !== "_") {
                    // Invert the dictionary
                    enumType._enumNames[enumType[item]] = item;
                }
            }
            return enumType._enumNames;
        }
        util.enumNames = enumNames;
        /**
         * Gets an enum name from an enum using the enum value
         */
        function enumName(enumValue, enumType) {
            var names = $dyn.util.enumNames(enumType);
            return names[enumValue];
        }
        util.enumName = enumName;
        function empty(element) {
            var child;
            if (element) {
                while (child !== element.lastChild) {
                    child = element.lastChild;
                    if (child) {
                        if (child.nodeType !== $dyn.util.HtmlNodeType.text && child.nodeType !== 8) { /* 8 is a comment */
                            $dyn.unbind(child);
                        }
                        $(child).remove();
                    }
                }
            }
        }
        util.empty = empty;
        function emptyfunction() { }
        util.emptyfunction = emptyfunction;
        /**
         * @deprecated
         */
        function encodeUrlPathSegment(urlPathSegment) {
            $dyn.logDeprecated("$dyn.util.encodeUrlPathSegment");
            // TODO: Work item #####: Encoding - url path segments
            return urlPathSegment;
        }
        util.encodeUrlPathSegment = encodeUrlPathSegment;
        /**
         * Check if an element matches the given selector
         * @description Represents a lightweight function that use the built-in selector matching api
         * @example $dyn.util.elementMatches.call(element, '*');
         * @returns True if the element matches the selector, else false.
         */
        util.elementMatches = HTMLElement.prototype.matches ||
            HTMLElement.prototype.matchesSelector ||
            HTMLElement.prototype.webkitMatchesSelector ||
            HTMLElement.prototype.msMatchesSelector ||
            HTMLElement.prototype.mozMatchesSelector ||
            HTMLElement.prototype.oMatchesSelector;
        /**
         * Filters a list of dom elements by a selector.
         * @param returns An array of the matched elements.
         */
        function filter(domElementList, selector) {
            var results = [];
            for (var i = 0, len = domElementList.length; i < len; i++) {
                var element = domElementList[i];
                if (element && $dyn.util.elementMatches.call(element, selector)) {
                    results.push(element);
                }
            }
            return results;
        }
        util.filter = filter;
        /**
         * Given a file path with the directory, and return the filename with ext
         */
        function parseFileNameWithDirectory(filePath) {
            if (!filePath) {
                return "";
            }
            var pattern = new RegExp("[\\\\/]");
            var fileNodes = filePath.split(pattern);
            return fileNodes[fileNodes.length - 1];
        }
        util.parseFileNameWithDirectory = parseFileNameWithDirectory;
        function elapsedTimeDisplayText(momentStartTime, momentEndTime) {
            var currentMomentUtc = momentEndTime;
            if (currentMomentUtc === undefined) {
                currentMomentUtc = moment.utc();
            }
            var duration = moment.duration(currentMomentUtc.diff(momentStartTime));
            var minutes = Math.abs(duration.asMinutes());
            if (minutes < 1) {
                return $dyn.label("Framework_ElapsedTimeLessThanMinute");
            }
            else if (minutes > 60) {
                return $dyn.label("Framework_ElapsedTimeMoreThanHour");
            }
            else {
                var numberOfMinutes = Math.floor(minutes);
                if (numberOfMinutes === 1) {
                    return $dyn.label("Framework_ElapsedTimeMinute");
                }
                else {
                    return $dyn.format($dyn.label("Framework_ElapsedTimeMinutes"), Math.floor(minutes).toString());
                }
            }
        }
        util.elapsedTimeDisplayText = elapsedTimeDisplayText;
        function waitForClientBusy() {
            return false;
        }
        util.waitForClientBusy = waitForClientBusy;
        function isWebKit() {
            if (navigator.webkitPersistentStorage) {
                return true;
            }
            return false;
        }
        util.isWebKit = isWebKit;
        /**
         * Determines if page is in RTL mode.
         * @description Checks if document body has dir element set to RTL
         *
         * @returns true if in RTL mode
         */
        function isRTLMode() {
            if (document.documentElement.dir !== "rtl") {
                return false;
            }
            return true;
        }
        util.isRTLMode = isRTLMode;
        function objectAssign(target) {
            var e_2, _a;
            var sources = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                sources[_i - 1] = arguments[_i];
            }
            try {
                for (var sources_1 = __values(sources), sources_1_1 = sources_1.next(); !sources_1_1.done; sources_1_1 = sources_1.next()) {
                    var source = sources_1_1.value;
                    if (source !== undefined && source !== null) {
                        for (var nextKey in source) {
                            if (source.hasOwnProperty(nextKey)) {
                                target[nextKey] = source[nextKey];
                            }
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (sources_1_1 && !sources_1_1.done && (_a = sources_1.return)) _a.call(sources_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return target;
        }
        util.objectAssign = objectAssign;
        if (Object.assign === undefined) {
            Object.assign = objectAssign;
        }
        function convertItems(items) {
            var controlItems = [];
            for (var j = 0; j < items.length; j++) {
                controlItems.push({
                    index: j,
                    text: items[j].Label,
                    value: items[j].Value,
                });
            }
            return controlItems;
        }
        util.convertItems = convertItems;
        /**
         * Gets the ControlLibrary.BigNumber options based on the wire format with control overrides expected by the dispatcher framework
         * @param control The control we want to get the value from
         * @param controlLib reference to the ControlLibrary object, this is needed for JSDispatcher to pass in the inner iframes ControlLibrary reference
         * since it isn't loaded on TestPage.htm
         */
        function createDispatcherBigNumOptions(control, controlLib) {
            var defaultFormat = controlLib.BigNumber.defaultFormat;
            var dispatcherFormat = $dyn.util.objectAssign({}, defaultFormat);
            var ignoreDecimal;
            if (control.TypeName === "Integer" || control.TypeName === "Int64") {
                dispatcherFormat.decimals = 0;
                ignoreDecimal = true;
                dispatcherFormat[","] = "";
            }
            else {
                ignoreDecimal = false;
                var controlAsReal = control;
                var decimals = $dyn.value(controlAsReal.NoOfDecimals);
                if (decimals !== undefined && decimals !== $dyn.ui.autoValue) {
                    dispatcherFormat.decimals = decimals;
                }
                var minNoOfDecimals = $dyn.value(controlAsReal.MinNoOfDecimals);
                if (minNoOfDecimals !== undefined && minNoOfDecimals !== $dyn.ui.autoValue) {
                    dispatcherFormat.minDecimals = minNoOfDecimals;
                }
                else {
                    delete dispatcherFormat.minDecimals;
                }
            }
            if ($dyn.value(control.SignDisplay) === $dyn.ui.SignDisplayType.None) {
                dispatcherFormat.pattern = ["n"];
            }
            var rotateSignStr = $dyn.value(control.RotateSign);
            var rotateSign;
            if (rotateSignStr === $dyn.ui.autoValue) {
                rotateSign = false;
            }
            else {
                rotateSign = $dyn.util.stringToBoolean(rotateSignStr);
            }
            // TODO: use big number options (needs to be exported from ControlLibrary)
            return {
                ignoreDecimal: ignoreDecimal,
                numberFormat: dispatcherFormat,
                rotateSign: rotateSign,
            };
        }
        util.createDispatcherBigNumOptions = createDispatcherBigNumOptions;
        /**
         * Function that gets the ControlLibrary.BigNumber options based off of a control and the default format
         * @param control where to get object overrides from
         * @returns the BigNumber options
         */
        function createBigNumOptions(control) {
            var defaultFormat = ControlLibrary.LocalizationManager.instance.getNumberFormat();
            var ignoreDecimal;
            var numberFormat = $dyn.util.objectAssign({}, defaultFormat);
            if (control.TypeName === "Integer" || control.TypeName === "Int64") {
                numberFormat.decimals = 0;
                ignoreDecimal = true;
                numberFormat[","] = "";
            }
            else {
                ignoreDecimal = false;
                var controlAsReal = control;
                var decimals = $dyn.value(controlAsReal.NoOfDecimals);
                if (decimals !== undefined && decimals !== $dyn.ui.autoValue) {
                    numberFormat.decimals = decimals;
                }
                var decimalSeparator = $dyn.value(controlAsReal.DecimalSeparator);
                if (decimalSeparator !== $dyn.ui.DecimalSeparator.auto) {
                    numberFormat["."] = decimalSeparator;
                }
                var thousandSeparator = $dyn.value(controlAsReal.ThousandSeparator);
                if (thousandSeparator !== $dyn.ui.ThousandSeparator.auto) {
                    numberFormat[","] = thousandSeparator;
                }
                var minNoOfDecimals = $dyn.value(controlAsReal.MinNoOfDecimals);
                if (minNoOfDecimals !== undefined && minNoOfDecimals !== $dyn.ui.autoValue) {
                    numberFormat.minDecimals = minNoOfDecimals;
                }
                else {
                    delete numberFormat.minDecimals;
                }
            }
            switch ($dyn.value(control.SignDisplay)) {
                case $dyn.ui.SignDisplayType.None:
                    numberFormat.pattern = ["n"];
                    break;
                case $dyn.ui.SignDisplayType.Prefixed:
                    numberFormat.pattern = ["-n"];
                    break;
                case $dyn.ui.SignDisplayType.Suffixed:
                    numberFormat.pattern = ["n-"];
                    break;
                case $dyn.ui.SignDisplayType.Parentheses:
                    numberFormat.pattern = ["(n)"];
                    break;
                case "Auto":
                default:
                    break;
            }
            var rotateSignStr = $dyn.value(control.RotateSign);
            var rotateSign;
            if (rotateSignStr === $dyn.ui.autoValue) {
                rotateSign = false;
            }
            else {
                rotateSign = $dyn.util.stringToBoolean(rotateSignStr);
            }
            var showZeroStr = $dyn.value(control.ShowZero);
            var showZero;
            if (showZeroStr === $dyn.ui.autoValue) {
                showZero = true;
            }
            else {
                showZero = $dyn.util.stringToBoolean(showZeroStr);
            }
            var displaceNegative = $dyn.value(control.DisplaceNegative);
            var hasDisplaceNegative = displaceNegative && displaceNegative !== $dyn.ui.autoValue && parseInt(displaceNegative, 10) > 0;
            // TODO: use big number options (needs to be exported from ControlLibrary)
            return {
                hasDisplaceNegative: hasDisplaceNegative,
                ignoreDecimal: ignoreDecimal,
                numberFormat: numberFormat,
                rotateSign: rotateSign,
                showZero: showZero,
            };
        }
        util.createBigNumOptions = createBigNumOptions;
        /**
         * Polyfill function for elementsFromPoint as it is not supported in all browsers
         * @param clientX x cordinate of the mouse pointer
         * @param clientY y cordinate of the mouse pointer
         */
        function elementsFromPoint(clientX, clientY) {
            var targets = [];
            if (document.elementsFromPoint) {
                targets = document.elementsFromPoint(clientX, clientY);
            }
            else if (document.msElementsFromPoint) {
                targets = document.msElementsFromPoint(clientX, clientY);
                // msElementsFromPoint returns null whenever the points are off the edge of the screen.
                // Convert it to an emtpy array
                targets = targets ? targets : [];
            }
            else if (document.elementFromPoint) {
                document.elementsFromPoint = function elementsFromPointPolyfill(x, y) {
                    var parentElements = [];
                    var parentElement;
                    do {
                        if (parentElement !== document.elementFromPoint(x, y)) {
                            parentElement = document.elementFromPoint(x, y);
                            parentElements.push(parentElement);
                            parentElement.style.pointerEvents = "none";
                        }
                        else {
                            parentElement = undefined;
                        }
                    } while (parentElement);
                    parentElements.forEach(function (element) {
                        return element.style.pointerEvents = "all";
                    });
                    return parentElements;
                };
                targets = document.elementsFromPoint(clientX, clientY);
            }
            return targets;
        }
        util.elementsFromPoint = elementsFromPoint;
        /**
         * @deprecated
         */
        function stringDup(str, count) {
            $dyn.logDeprecated("$dyn.util.stringDup");
            var dup = "";
            for (var i = 0; i < count; i++) {
                dup += str;
            }
            return dup;
        }
        util.stringDup = stringDup;
        /**
         * Set the visibility of an element.
         * @description Sets the HTMLElement.style.display to "" or "none" and also updated the 'data-dyn-lastvisible'
         *              attribute based on visible. Will also queue the element for an arrange if it has the
         *              layout-root-scope marker.
         * @param targetElement The HTML Element we are changing the visiblity on.
         * @param visible Visibility to make the element.
         * @param defaultState Default value of visiblity.
         */
        function setVisibility(targetElement, visible, defaultState) {
            if (defaultState === void 0) { defaultState = true; }
            if (defaultState === undefined) {
                defaultState = true;
            }
            // By default, visible assumes that all elements start in a "visible" state.
            var lastValue;
            var lastVisibleAttributeValue = targetElement.getAttribute("data-dyn-lastvisible");
            if (lastVisibleAttributeValue === undefined || lastVisibleAttributeValue === null) {
                lastValue = defaultState;
            }
            else {
                if (lastVisibleAttributeValue === "true") {
                    lastValue = true;
                }
                else if (lastVisibleAttributeValue === "false") {
                    lastValue = false;
                }
            }
            if (visible) {
                if (!lastValue) {
                    targetElement.style.display = "";
                    targetElement.removeAttribute("aria-hidden");
                }
            }
            else if (lastValue) {
                targetElement.style.setProperty("display", "none", "important");
                targetElement.setAttribute("aria-hidden", "true");
            }
            targetElement.setAttribute("data-dyn-lastvisible", visible ? "true" : "false");
            // Note: Can't use a bitwise XOR here as these aren't necessarily booleans.
            if ((!lastValue && visible) || (lastValue && !visible)) {
                // The element should be queued for an arrange only if it has the layout-root-scope marker. It will only
                // have this marker if it is an independent element (absolute, relative positioning, or it does not need a
                // size assigned by its parent container)
                if (targetElement.classList.contains($dyn.layout.RootScopeMarker)) {
                    if (visible) {
                        // Since we have the root scope marker on the element, we only want to run layout if it is being
                        // shown, no need to run it on hide.
                        $dyn.layout.queueArrange(targetElement);
                    }
                }
                else {
                    $dyn.layout.queueArrange(targetElement.parentNode);
                }
            }
        }
        util.setVisibility = setVisibility;
        /**
         * Deselects text on the target element.
         * @description Wrapper for $dyn.ui.selectionEnd and $dyn.ui.selectionStart.
         */
        function deselectText(targetElement) {
            if (targetElement) {
                $dyn.ui.selectionEnd(targetElement, 0);
                $dyn.ui.selectionStart(targetElement, 0);
            }
            var sel = $dyn.ui.getSelection();
            if (sel) {
                try {
                    if (sel.removeAllRanges && sel.rangeCount > 0 && sel.getRangeAt(0).getClientRects().length > 0) {
                        sel.removeAllRanges();
                    }
                }
                catch (ignore) {
                    // Edge (25.10586.0.0) was still giving an error 800a025e, even after adding if checks for empty selection
                }
            }
        }
        util.deselectText = deselectText;
        /**
         * Returns true if the text in the control was clicked, false if the white space was clicked.
         */
        function clickedText(targetElement) {
            // TODO TFS:3745038 Don't use jQuery
            if ($(targetElement).hasClass("lookupButton")) {
                // If the lookup button is clicked return false.
                return false;
            }
            else if (!(targetElement instanceof HTMLInputElement)) {
                // If not a lookup button or input tag, return true. Checking selectionEnd only makes sense for input tags.
                return true;
            }
            var valueAsStr = targetElement.value;
            var selectionStart = $dyn.ui.selectionStart(targetElement);
            // Only IE allows selectionEnd to be undefined, in chrome setting selectionEnd to undefined will result in the selectionEnd being 0
            return valueAsStr && valueAsStr.length > 0 && selectionStart < valueAsStr.length;
        }
        util.clickedText = clickedText;
        /**
         * Add the loading animation class to a controlElement.
         * @description Remove the loading animation when all pending interactions are complete (clientBusy changes back to
         *              false). Optionally provide a condition which must be fulfilled in order for the animation to be
         *              removed, and/or a function to call before removing the animation.
         * @remarks Note that only one activeIsLoading animation can be created for a control at one time. This may lead to
         *          issues if there are more custom conditions/steps that are specified.
         *          Currently the only use case for those optional parameters is for opening the lookup, which must complete
         *          first before any of the other steps can be taken anyway.
         * @param controlElement The element to add the loading animation to.
         * @param currentContext The context with which to do additional checks/steps.
         * @param shouldRemoveAnimation Function specifying additional conditions which must be fulfilled to remove animation.
         * @param preRemoveAnimationFunction Function specifying additional steps to take before removing animation.
         */
        function activateLoadingAnimation(controlElement, currentContext, shouldRemoveAnimationFunction, preRemoveAnimationFunction) {
            if ($dyn.clientBusy()) {
                var subscriberId_1;
                var previousLoadingAnimationExists = false;
                var liveControl_1; // TODO: use control type when available
                // Do not add a new loading animation to a control if one already exists.
                if (controlElement) {
                    liveControl_1 = $dyn.ui.getLiveControl(controlElement);
                    previousLoadingAnimationExists = liveControl_1 && liveControl_1.getActiveIsLoadingAnimation && liveControl_1.getActiveIsLoadingAnimation();
                }
                if (!previousLoadingAnimationExists) {
                    var loadSpinnerId_1 = $dyn.util.addLoadingAnimation(controlElement);
                    if (liveControl_1 && liveControl_1.setActiveIsLoadingAnimation) {
                        liveControl_1.setActiveIsLoadingAnimation({
                            cancel: function (removeSpinner) {
                                removeSpinner = removeSpinner === undefined ? true : removeSpinner;
                                if (removeSpinner) {
                                    $dyn.util.removeLoadingAnimation(controlElement);
                                }
                                liveControl_1.setActiveIsLoadingAnimation(undefined);
                                if (subscriberId_1) {
                                    $dyn.clientBusy.valueChanged.unsubscribe(subscriberId_1);
                                }
                                if (loadSpinnerId_1) {
                                    clearTimeout(loadSpinnerId_1);
                                    loadSpinnerId_1 = undefined;
                                }
                            },
                        });
                    }
                    subscriberId_1 = $dyn.clientBusy.valueChanged.subscribe(function () {
                        if (!$dyn.clientBusy()) {
                            if (loadSpinnerId_1) {
                                clearTimeout(loadSpinnerId_1);
                                loadSpinnerId_1 = undefined;
                            }
                            var shouldRemoveAnimation = shouldRemoveAnimationFunction ? shouldRemoveAnimationFunction.apply(currentContext) : true;
                            if (shouldRemoveAnimation) {
                                $dyn.callFunction(preRemoveAnimationFunction, currentContext);
                                if (controlElement) {
                                    $dyn.util.removeLoadingAnimation(controlElement);
                                    if (liveControl_1 && liveControl_1.listControl && liveControl_1.listControl.ControlLibGridRef) {
                                        var lookupControlRef = liveControl_1.listControl.ControlLibGridRef.getActiveCellRef(liveControl_1.Name);
                                        if (lookupControlRef && lookupControlRef.getControlRef) {
                                            lookupControlRef = lookupControlRef.getControlRef();
                                            if (lookupControlRef && lookupControlRef.setSpinnerState) {
                                                lookupControlRef.setSpinnerState(false);
                                            }
                                        }
                                    }
                                    if (liveControl_1 && liveControl_1.setActiveIsLoadingAnimation) {
                                        liveControl_1.setActiveIsLoadingAnimation(undefined);
                                    }
                                }
                            }
                            $dyn.clientBusy.valueChanged.unsubscribe(subscriberId_1);
                        }
                    });
                }
            }
        }
        util.activateLoadingAnimation = activateLoadingAnimation;
        /**
         * After delay, add the 'is-loading' class to the element.
         * @returns The timeout Id.
         */
        function addLoadingAnimation(controlElement) {
            return window.setTimeout(function () {
                if (controlElement) {
                    controlElement.classList.add("is-loading");
                }
            }, 1000);
        }
        util.addLoadingAnimation = addLoadingAnimation;
        /**
         * Remove the 'is-loading' class from the element.
         */
        function removeLoadingAnimation(controlElement) {
            if (controlElement) {
                controlElement.classList.remove("is-loading");
            }
        }
        util.removeLoadingAnimation = removeLoadingAnimation;
        /**
         * Determines whether candidateContext exists in the hierarchy of contexts contained by candidateRoot.
         * @description Recurses its way up the hierarchy.
         * @param candidateRoot The root context.
         * @param candidateContext The child context.
         */
        function isRootedBy(candidateRoot, candidateContext) {
            if (candidateRoot === candidateContext) {
                return true;
            }
            else if (candidateContext.Root) {
                return $dyn.util.isRootedBy(candidateRoot, candidateContext.Root);
            }
            return false;
        }
        util.isRootedBy = isRootedBy;
        /**
         * Swaps two DOM elements.
         * @remarks The DOM elements do not need to share the same parent.
         * @param element The first element.
         * @param swapElement The second element.
         */
        function swap(element, swapElement) {
            var parentelement = element.parentNode;
            var parentswapElement = swapElement.parentNode;
            var location = swapElement.nextSibling;
            if (location === element) {
                location = location.nextSibling;
                parentelement.insertBefore(element, swapElement);
            }
            else {
                parentelement.replaceChild(swapElement, element);
                if (location) {
                    parentswapElement.insertBefore(element, location);
                }
                else {
                    parentswapElement.appendChild(element);
                }
            }
        }
        util.swap = swap;
        /**
         * Merger the attributes from one Element to another.
         * @param from The source element to copy attributes from.
         * @param to The destination element to copy attritbutes to.
         */
        function mergeAttributes(from, to) {
            var attrs = from.attributes;
            var len = attrs.length;
            for (var i = 0; i < len; i++) {
                var attr = attrs[i];
                to.setAttribute(attr.name, attr.value);
            }
        }
        util.mergeAttributes = mergeAttributes;
        /**
         * @deprecated
         */
        function renderForEach(targetElement, role, itemTemplateElement, selectedTemplateElement, data, dataContext, selectedIndexGetter) {
            $dyn.logDeprecated("$dyn.util.renderForeach");
            // Clear existing children
            $dyn.util.empty(targetElement);
            var list = document.createDocumentFragment();
            itemTemplateElement.classList.remove("dyn-prototype");
            list.appendChild(itemTemplateElement);
            if ($dyn.debug.profile && window.console && console.profile) {
                if (console.timeStamp) {
                    console.timeStamp("foreach begin");
                }
                console.profile("foreach");
            }
            var startTime = performance.now();
            // Data is an array on which we are supposed to repeat
            if (data) {
                if (itemTemplateElement) {
                    for (var i = 0, len = data.length; i < len; i++) {
                        var arrayItem = data[i];
                        // Make the array-item the new dataContext, add $index scope var
                        // Cloning the template for an instance
                        var instanceElement = void 0;
                        // Apply data-binding to this element
                        if (selectedIndexGetter() === i) {
                            // TODO: Shouldn't be cloning this node?
                            var itemDataContext = new $dyn.DataContext(arrayItem, dataContext);
                            itemDataContext.scopeVars.$index = i;
                            instanceElement = selectedTemplateElement.cloneNode(true);
                            instanceElement.setAttribute("aria-posinset", (i + 1));
                            instanceElement.setAttribute("aria-selected", "true");
                            $dyn.role(instanceElement).doDataBinding(itemDataContext);
                        }
                        else {
                            var itemDataContext = new $dyn.DataContext(arrayItem, dataContext);
                            itemDataContext.scopeVars.$index = i;
                            instanceElement = itemTemplateElement.cloneNode(true);
                            instanceElement.setAttribute("aria-posinset", (i + 1));
                            instanceElement.classList.add("dyn-virtual");
                            role.dataBindItem(instanceElement, itemDataContext);
                        }
                        // Add the instance as a child
                        list.appendChild(instanceElement);
                    }
                }
            }
            targetElement.appendChild(list);
            list = null;
            itemTemplateElement.classList.add("dyn-prototype");
            var endTime = performance.now();
            if ($dyn.debug.profile && window.console && console.profile) {
                console.log("foreach: " + (endTime - startTime));
                console.profileEnd();
                if (console.timeStamp) {
                    console.timeStamp("foreach end");
                }
            }
        }
        util.renderForEach = renderForEach;
        /**
         * Observes the content and executes the callback when there is a change
         * @deprecated
         * @param contentToObserve the actual content to observe
         * @param target target element whose content change is being observed
         * @param contentChangedCallback Callback function that needs to be executed
         */
        function observeContent(contentToObserve, target, contentChangedCallback) {
            var isObservable = false;
            if ($dyn.isObservable(contentToObserve)) {
                isObservable = true;
            }
            target[0].dynContent = $dyn.observe(contentToObserve, contentChangedCallback);
            if (isObservable) {
                target[0].dynContent.contentChanged = function () {
                    contentChangedCallback($dyn.value(contentToObserve));
                };
            }
            else {
                target[0].dynContent.contentChanged = function () {
                    contentChangedCallback(contentToObserve());
                };
            }
        }
        util.observeContent = observeContent;
        /**
         * Calculates size of an associative array
         * @param associativeArray Associative array whose size has to be calculated
         * @returns size of the associative array
         */
        function calculateAssociativeArraySize(associativeArray) {
            var size = 0;
            for (var key in associativeArray) {
                if (associativeArray.hasOwnProperty(key)) {
                    size++;
                }
            }
            return size;
        }
        util.calculateAssociativeArraySize = calculateAssociativeArraySize;
        /**
         * checks if the element is covered by another scrolled off screen
         * @param _element element to check if it is underneath any other element
         * @param _ignoreElement we can ignore this element as a overlap
         * @returns true if behind
         */
        function isBehindOtherElement(_element, _ignoreElement) {
            var boundingRect = _element.getBoundingClientRect();
            // adjust coordinates to get more accurate results
            var left = boundingRect.left + 1;
            var right = boundingRect.right - 1;
            var top = boundingRect.top + 1;
            var bottom = boundingRect.bottom - 1;
            if (document.elementFromPoint(left, top) && document.elementFromPoint(left, top).parentNode === _element) {
                // did we get a parent and child node
                return false;
            }
            // when calculating overlap - we special case out any match on ignoreElement
            if (_ignoreElement === undefined) {
                _ignoreElement = _element; // not passed so set to _element
            }
            // get left top
            var elemFound = document.elementFromPoint(left, top);
            if (elemFound !== _ignoreElement && elemFound !== _element) {
                return true;
            }
            // get right top
            elemFound = document.elementFromPoint(right, top);
            if (elemFound !== _ignoreElement && elemFound !== _element) {
                return true;
            }
            // get left bottom
            elemFound = document.elementFromPoint(left, bottom);
            if (elemFound !== _ignoreElement && elemFound !== _element) {
                return true;
            }
            // get right bottom
            elemFound = document.elementFromPoint(right, bottom);
            if (elemFound !== _ignoreElement && elemFound !== _element) {
                return true;
            }
            return false;
        }
        util.isBehindOtherElement = isBehindOtherElement;
        /**
         * checks if the element is in view
         */
        function isElementInView(_element) {
            var el = $(_element);
            var elemDisplayNotNone = el.css("display") !== "none";
            // get height data
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + window.innerHeight;
            var elemTop = el.offset().top;
            var elemBottom = elemTop + el.height();
            // get width data
            var docViewLeft = $(window).scrollLeft();
            var docViewRight = docViewLeft + window.innerWidth;
            var elemLeft = el.offset().left;
            var elemRight = elemLeft + el.width();
            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop) && (elemRight <= docViewRight) && (elemLeft >= docViewLeft) && elemDisplayNotNone);
        }
        util.isElementInView = isElementInView;
        /**
         * checks if string has a doublebyte character
         * @param stringVal string to look at
         * @returns true if has doublebyte
         */
        function stringHasDoubleByte(stringVal) {
            return /[^\u0000-\u00ff]/.test(stringVal);
        }
        util.stringHasDoubleByte = stringHasDoubleByte;
        /**
         * Position a flyout.
         * @param options Flyout options.
         * @param currentFlyout The flyout.
         */
        function position(options, currentFlyout) {
            // TODO: Move to flyout helper file?
            if (options.flyout && currentFlyout && options.flyout !== currentFlyout) {
                $dyn.log("$dyn.util.position has a different flyout in options than currentFlyout.");
            }
            // Assume the currentFlyout is the correct flyout to position and have the options.flyout be the secondary
            var flyout = currentFlyout || options.flyout;
            var of = $dyn.callFunction(options.getAnchor) || (options.of ? options.of : null);
            // Position only you have a anchor element to position flyout
            if (!$dyn.util.isFlyoutAPhoneLookup($(flyout), of)) {
                var at = void 0;
                var my = void 0;
                if (!$dyn.util.isRTLMode()) {
                    at = options.at !== undefined ? options.at : "left bottom";
                    my = options.my !== undefined ? options.my : "left top";
                }
                else {
                    at = options.at !== undefined ? options.at : "right bottom";
                    my = options.my !== undefined ? options.my : "right top";
                }
                var collision = options.collision !== undefined ? options.collision : "";
                var usingFunction = options.using ? options.using : null;
                var withinContainer = options.within ? options.within : null;
                // Task #3840166 is logged to investigate more robust approch to address positioning issues
                // This will cause jqueryui.position to use absolute positioning instead of relative.
                // Necessary for when multiple flyout are present so that they do not impact each other.
                if (!$dyn.util.isRTLMode()) {
                    var existingFlyouts = $("body > .sysPopup");
                    var previousFlyout = existingFlyouts[existingFlyouts.length - 2];
                    $(previousFlyout).css("position", "absolute");
                }
                else {
                    // Due to an issue with jquery ui with RTL we fall back to the old logic for RTL
                    $(flyout).css("position", "absolute");
                }
                flyout.position({ of: of, my: my, at: at, collision: collision, using: usingFunction, within: withinContainer });
            }
        }
        util.position = position;
        /**
         * Gets a recordability object, which is used by TaskRecorder and provides copy/paste/validate functionality
         * @description Recordability object must be invoked with this object that points to target control.
         * @internal
         * @returns Recordability object
         */
        function recordabilityDefault() {
            return {
                copy: !this.copy_Value ? undefined : function (callback) {
                    $dyn.callFunction(this.copy_Value, this, [], function (copyBookmark) {
                        if (callback) {
                            callback({ Value: copyBookmark.Value, Id: copyBookmark.ReferenceId, Label: copyBookmark.Label });
                        }
                    });
                },
                paste: !this.paste_Value ? undefined : function (id, value) {
                    $dyn.callFunction(this.paste_Value, this, [id, value]);
                },
                validate: !this.validate_Value ? undefined : function (id) {
                    $dyn.callFunction(this.validate_Value, this, [id]);
                },
                validateAllowEditMode: !$dyn.value(this.ValidateEditableAllowed) ? undefined : function () {
                    $dyn.callFunction(this.validate_AllowEdit, this, []);
                },
                validateDisabled: !$dyn.value(this.ValidateDisabledAllowed) ? undefined : function () {
                    $dyn.callFunction(this.validate_Enabled, this, []);
                },
                validateEnabled: !$dyn.value(this.ValidateEnabledAllowed) ? undefined : function () {
                    $dyn.callFunction(this.validate_Enabled, this, []);
                },
                validateReadOnlyMode: !$dyn.value(this.ValidateReadOnlyAllowed) ? undefined : function () {
                    $dyn.callFunction(this.validate_AllowEdit, this, []);
                }
            };
        }
        util.recordabilityDefault = recordabilityDefault;
        /**
         * Sets focus to the control element
         * @remarks Updates the $dyn.focusCompeted flag
         * @internal
         */
        function focusElement(controlElement, controlName) {
            var elementToFocus;
            if ($(controlElement.getAttribute("data-dyn-focus"), controlElement).length > 0) {
                var first = $(controlElement.getAttribute("data-dyn-focus"), controlElement).first();
                // first.is(':focus') doesn't always return whether the control has focus.
                // Hence adding an additional check to see if document.activeElement is the same as the controlElement that focus is being set to.
                // If yes, skip setting focus.
                if (first.is(":focus") || document.activeElement === controlElement) {
                    $dyn.log.focus && $dyn.log.focus("Focus: Control was already focused: %s", controlName || controlElement ? controlElement.getAttribute("data-dyn-controlname") : "");
                    $dyn.focusCompleted(true);
                    return;
                }
                else {
                    elementToFocus = first[0];
                }
            }
            else {
                elementToFocus = controlElement;
            }
            // Set focus to the control.
            elementToFocus.focus();
            // Update the focusCompleted flag
            $dyn.focusCompleted(true);
            $dyn.log.focus && $dyn.log.focus("Focus: Control->Setting focus to %s completed", controlName || controlElement ? controlElement.getAttribute("data-dyn-controlname") : "");
        }
        util.focusElement = focusElement;
        /**
         * Finds the first element that should take focus.
         * @remarks If prioritizeInputs and prioritizeEditable are not false it will find the first editable input or textarea element inside of the container specified.
         * @internal
         * @returns The first focusable element, otherwise undefined
         */
        function findFirstFocusableControl(containerElement, prioritizeInputs, prioritizeEditable, ignoreFilters) {
            // Personalization handles it's own focus
            if ($dyn.ax.personalizationUtil && $dyn.ax.personalizationUtil.isPersonalizationModeTurnedOn()) {
                return;
            }
            var $element = $(containerElement);
            var firstFocusableSelector = ":tabbable";
            var selectorToIgnore = ".ignore-first-focus";
            var controls = $();
            var enhancedTabSequence = $dyn.util.isEnhancedTabSequenceEnabled();
            // if enhancedTabSequence is on focus the first focusable element.
            if (prioritizeInputs !== false && !enhancedTabSequence) {
                // try to find the first text input element
                if (prioritizeEditable !== false) {
                    controls = $element
                        .find("input, textarea")
                        .filter(firstFocusableSelector + ":not([readonly])")
                        .not(selectorToIgnore);
                    if (ignoreFilters && controls.length) {
                        controls = controls.filter(function () {
                            return $(this).parents(".quickFilter").length === 0;
                        });
                    }
                }
                if (controls.length === 0) {
                    controls = $element
                        .find("input, textarea")
                        .filter(firstFocusableSelector)
                        .not(selectorToIgnore);
                }
            }
            if (controls.length === 0) {
                // find the first element of any type that's focusable
                controls = $element.find(firstFocusableSelector).not(selectorToIgnore);
                if (controls.length) {
                    var control = controls[0];
                    // If the control has data-dyn-focus, instead focus the thing matching
                    // that selector.
                    var dynFocusSelector = control.getAttribute("data-dyn-focus");
                    if (dynFocusSelector) {
                        controls = $(control).find(dynFocusSelector);
                    }
                }
            }
            if (controls.length) {
                // don't need :first selector because we are grabbing the first element here
                return controls[0];
            }
            $dyn.log.focus && $dyn.log.focus.error && $dyn.log.focus.error("Focus: findFirstFocusableControl no controls to focus inside %o", $element[0]);
            return undefined;
        }
        util.findFirstFocusableControl = findFirstFocusableControl;
        /**
         * Get the first tabbable element within a container element
         * @returns The first tabbable element
         */
        function findFirstTabbableControl(containerElement) {
            return $(containerElement).find(":tabbable:not(.firstFocusable)").first()[0];
        }
        util.findFirstTabbableControl = findFirstTabbableControl;
        /**
         * Get the last tabbable element within a container element
         * @returns The last tabbable element
         */
        function findLastTabbableControl(containerElement) {
            return $(containerElement).find(":tabbable:not(.lastFocusable)").last()[0];
        }
        util.findLastTabbableControl = findLastTabbableControl;
        /**
         * Check if the childElement has focus
         * @returns If the control is focused, return true; otherwise false.
         */
        function isControlFocused(childElement, root) {
            if (childElement && $(childElement.getAttribute("data-dyn-focus"), childElement).length > 0) {
                var $first = $(childElement.getAttribute("data-dyn-focus"), childElement).first();
                if ($first && ($first.is(":focus") || document.activeElement === $first[0])) {
                    $dyn.log.focus &&
                        $dyn.log.focus("Focus: Form(Form.Id: %s)->isControlFocused (control is focused no-op) control name: %s ", root.Id, childElement.getAttribute("data-dyn-controlname"));
                    // make sure the ActiveElement is also correct
                    if (root && root.ActiveElement() === childElement) {
                        return true;
                    }
                }
            }
            return false;
        }
        util.isControlFocused = isControlFocused;
        /**
         * Check if the element is the same column as the activeElement
         * @returns If the column is focused, return true; otherwise false.
         */
        function isColumnFocused(element) {
            if (element && document.activeElement) {
                var $controlElement = $(element).closest("[data-dyn-controlname]");
                var controlName = $controlElement.attr("data-dyn-controlname");
                var $focusElement = $(document.activeElement).closest("[data-dyn-controlname]");
                var focusName = $focusElement.attr("data-dyn-controlname");
                if (controlName === focusName) {
                    return true;
                }
            }
            return false;
        }
        util.isColumnFocused = isColumnFocused;
        /**
         * Check if the childElement is a child of the parentElement
         * @returns True if childElement is a child of the parentElement; otherwise, false
         */
        function isChild(parentElement, childElement) {
            if (!parentElement || !childElement) {
                return false;
            }
            var isChildFlag = false;
            var parentChain = $(childElement).parents().addBack();
            if (parentChain.filter(function (index) {
                return parentChain[index] === parentElement;
            }).length !== 0) {
                isChildFlag = true;
            }
            return isChildFlag;
        }
        util.isChild = isChild;
        /**
         * Check if the element has a data-dyn-formid attribute
         * @returns True if childElement is a form; otherwise, false
         */
        function isForm(element) {
            return element.hasAttribute("data-dyn-formid");
        }
        util.isForm = isForm;
        /**
         * Setup tabbing container behavior on a container
         * @param containerElement
         * @param regionTitle
         * @param noAriaLive optional flag to opt-out of announcing the regionTitle via aria-live when the user tabs into the container. See: TFS#3922722.
         * @param noMutationObserver optional flag to skip the mutation observer path.
         * @returns The dispose function needed to clean up the jquery event handlers
         */
        function tabbingContainer(containerElement, regionTitle, noAriaLive, noMutationObserver) {
            if (!containerElement) {
                return $dyn.util.emptyfunction;
            }
            var $containerElement = $(containerElement);
            if (regionTitle && noAriaLive !== true) {
                $containerElement.on("focusin.tabbingContainer", function (event) {
                    // if the focus attribute is not set set it to fire aria live to announce the tab container has recieved focus
                    // if the focus attribute is set we have announced it before so dont do it for each focus in the container
                    if (!$containerElement.attr("dyn-has-focus")) {
                        $containerElement.attr("dyn-has-focus", "true");
                    }
                });
            }
            $containerElement.prepend('<div aria-hidden="true" tabindex="0" class="firstFocusable ignore-first-focus"></div>');
            $containerElement.append('<div aria-hidden="true" tabindex="0" class="lastFocusable ignore-first-focus"></div>');
            var observer;
            if (!noMutationObserver) {
                // create an observer instance
                observer = new MutationObserver(function (mutations) {
                    observer.disconnect();
                    if (!$containerElement.find(":tabbable").first().hasClass("firstFocusable")) {
                        var firstTabStop = $containerElement.children(".firstFocusable").detach();
                        if (firstTabStop && firstTabStop.length) {
                            $containerElement.prepend(firstTabStop);
                        }
                    }
                    if (!$containerElement.find(":tabbable").last().hasClass("lastFocusable")) {
                        var lastTabStop = $containerElement.children(".lastFocusable").detach();
                        if (lastTabStop && lastTabStop.length) {
                            $containerElement.append(lastTabStop);
                        }
                    }
                    observer.observe(containerElement, config_1);
                });
                // configuration of the observer:
                var config_1 = { childList: true };
                // pass in the target node, as well as the observer options
                observer.observe(containerElement, config_1);
            }
            var tabPressed = false;
            var shiftTabPressed = false;
            $containerElement.on("keydown.tabbingContainer", function (evt) {
                if (evt.which === $dyn.ui.KeyCodes.tab) {
                    if (evt.shiftKey) {
                        shiftTabPressed = true;
                    }
                    else {
                        tabPressed = true;
                    }
                }
            });
            $containerElement.on("focusout.tabbingContainer", function (event) {
                var destinatonTargetElement = document.activeElement;
                if (event && event.relatedTarget) {
                    destinatonTargetElement = event.relatedTarget;
                }
                if ($(destinatonTargetElement).closest(containerElement).length <= 0) {
                    tabPressed = false;
                    shiftTabPressed = false;
                }
                // clear the value only when we leave the container. This makes sure the aria live is only read
                // when the tab container initial takes focus not each time a contained element takes focus
                // as we check for content in the focusin handler
                if (regionTitle && !$.contains($containerElement[0], destinatonTargetElement)) {
                    $containerElement.removeAttr("dyn-has-focus");
                }
            });
            $containerElement.children(".firstFocusable").on("focusin.tabbingContainer", function (evt) {
                if (shiftTabPressed) {
                    var lastFocusable = $dyn.util.findLastTabbableControl(containerElement);
                    var lastControl = $dyn.context(lastFocusable);
                    if (lastControl && lastControl.element) {
                        // Scroll the entire control element into view
                        lastControl.element.scrollIntoView();
                    }
                    else if (lastFocusable) {
                        lastFocusable.scrollIntoView();
                    }
                    $dyn.log.focus && $dyn.log.focus("TabbingContainer Focus: Set focus to last focusable control in container: %s", containerElement.id);
                    if (lastFocusable) {
                        lastFocusable.focus();
                    }
                    evt.stopPropagation();
                }
                else {
                    var firstFocusable = $dyn.util.findFirstTabbableControl(containerElement);
                    var firstControl = $dyn.context(firstFocusable);
                    if (firstControl && firstControl.element) {
                        // Scroll the entire control element into view
                        firstControl.element.scrollIntoView();
                    }
                    else if (firstFocusable) {
                        firstFocusable.scrollIntoView();
                    }
                    $dyn.log.focus && $dyn.log.focus("TabbingContainer Focus: Set focus to first focusable control in container: %s", containerElement.id);
                    if (firstFocusable) {
                        firstFocusable.focus();
                    }
                    evt.stopPropagation();
                }
            });
            $containerElement.children(".lastFocusable").on("focusin.tabbingContainer", function (evt) {
                if (tabPressed) {
                    var firstFocusable = $dyn.util.findFirstTabbableControl(containerElement);
                    var firstControl = $dyn.context(firstFocusable);
                    if (firstControl && firstControl.element) {
                        // Scroll the entire control element into view
                        firstControl.element.scrollIntoView();
                    }
                    else if (firstFocusable) {
                        firstFocusable.scrollIntoView();
                    }
                    $dyn.log.focus && $dyn.log.focus("TabbingContainer Focus: Set focus to first focusable control in container: %s", containerElement.id);
                    if (firstFocusable) {
                        firstFocusable.focus();
                    }
                    evt.stopPropagation();
                }
                else {
                    var lastFocusable = $dyn.util.findLastTabbableControl(containerElement);
                    var lastControl = $dyn.context(lastFocusable);
                    if (lastControl && lastControl.element) {
                        // Scroll the entire control element into view
                        lastControl.element.scrollIntoView();
                    }
                    else if (lastFocusable) {
                        lastFocusable.scrollIntoView();
                    }
                    $dyn.log.focus && $dyn.log.focus("TabbingContainer Focus: Set focus to last focusable control in container: %s", containerElement.id);
                    if (lastFocusable) {
                        lastFocusable.focus();
                    }
                    evt.stopPropagation();
                }
            });
            return function disposeTabbingContainerEventHandlers() {
                if (!noMutationObserver && observer) {
                    observer.disconnect();
                    observer = undefined;
                }
                $containerElement.off(".tabbingContainer");
                $containerElement
                    .children(".firstFocusable, .lastFocusable")
                    .off(".tabbingContainer")
                    .remove();
            };
        }
        util.tabbingContainer = tabbingContainer;
        /**
         * Setup scrolling container behavior on a container
         * @returns The dispose function needed to clean up the jquery event handlers
         */
        function scrollingContainer(containerElement, _id, _eventCallBack) {
            if (!containerElement) {
                return $dyn.util.emptyfunction;
            }
            var $containerElement = $(containerElement);
            // bind to scroll event of the callback scrollable parent in order to handle the scroll events
            var scrollParent = $containerElement.scrollParent();
            $containerElement.scrollParents = [];
            while (scrollParent.length > 0 && scrollParent[0] !== document) {
                // store the scroll parent to use for unbinding on close
                $containerElement.scrollParents.push(scrollParent);
                scrollParent.on("scroll." + _id, function () {
                    _eventCallBack(_id);
                });
                scrollParent = scrollParent.scrollParent();
            }
            return function disposeScrollingContainerEventHandlers() {
                if ($containerElement.scrollParents) {
                    // tslint:disable-next-line:prefer-for-of
                    for (var i = 0; i < $containerElement.scrollParents.length; i++) {
                        $containerElement.scrollParents[i].off("scroll." + _id);
                    }
                    $containerElement.scrollParents = [];
                }
            };
        }
        util.scrollingContainer = scrollingContainer;
        /**
         * Make all children control's of the container control valid
         * @internal
         */
        function validateChildren(containerControl) {
            if (containerControl && containerControl.Root && containerControl.Root.HasInvalidControls()) {
                var containerChildren = $dyn.value(containerControl.Children);
                if (containerChildren && containerChildren.length) {
                    for (var i = 0, len = containerChildren.length; i < len; i++) {
                        if (containerChildren[i]) {
                            if (containerChildren[i].IsValid) {
                                containerChildren[i].IsValid(true);
                            }
                            if (containerChildren[i].Children) {
                                $dyn.util.validateChildren(containerChildren[i]);
                            }
                        }
                    }
                }
            }
        }
        util.validateChildren = validateChildren;
        /**
         * Function to load a java script file
         * @param scriptPath The file path.
         * @param callback The callback function when loading is done.
         */
        function includeJavaScript(scriptPath, callback) {
            if (callback && typeof (callback) !== "function") {
                var error_1 = "Error loading file " + scriptPath + ". callback has wrong type, expected type 'function', got '" + typeof (callback) + "'";
                $dyn.error({ Message: error_1, Label: error_1 });
            }
            // Adding the script tag to the head
            var head = document.getElementsByTagName("head")[0];
            var script = document.createElement("script");
            script.setAttribute("type", "text/javascript");
            script.setAttribute("src", scriptPath);
            var callbackCalled = false;
            /** Callback function type for includeJavaScript. */
            var callbackFunction = function () {
                if (!callbackCalled) {
                    if (callback) {
                        callback();
                    }
                    $dyn.async.pending.decrement("Finished loading " + scriptPath);
                    script.onreadystatechange = null;
                    script.onload = null;
                    callbackCalled = true;
                }
            };
            // Then bind the event to the callback function.
            // There are several events for cross browser compatibility.
            script.onreadystatechange = function () {
                if (script.readyState === "complete") {
                    callbackFunction();
                }
            };
            script.onload = callbackFunction;
            // Fire the loading
            $dyn.async.pending.increment("Started loading " + scriptPath);
            head.appendChild(script);
        }
        util.includeJavaScript = includeJavaScript;
        /**
         * Function to load a java script file
         * @param scriptPathArray The list of scripts file path to be loaded.
         * @param index The recursive index.
         * @param notifier The observable to be set to true when all the scripts are loaded.
         */
        function includeJavaScripts(scriptPathArray, index, notifier) {
            if (scriptPathArray.length === index) {
                notifier(true, true);
                return;
            }
            var callback = function () { return $dyn.util.includeJavaScripts(scriptPathArray, index + 1, notifier); };
            $dyn.util.includeJavaScript(scriptPathArray[index], callback);
        }
        util.includeJavaScripts = includeJavaScripts;
        function copyMessageDiagnosticsToClipBoard(messageForm) {
            var copyButton = document.activeElement;
            var clipDataArea = document.createElement("textarea");
            clipDataArea.value = $dyn.value(messageForm.TitleText) + "\n";
            clipDataArea.value = $dyn.value($dyn.browserActivity.TraceLogTenant) ?
                clipDataArea.value + $dyn.label("MessageBox_Tenant") + $dyn.value($dyn.browserActivity.TraceLogTenant) + "\n" : clipDataArea.value;
            clipDataArea.value = $dyn.value(messageForm.BrowserSessionActivityId) ? clipDataArea.value + $dyn.value(messageForm.BrowserSessionActivityId) + "\n" : clipDataArea.value;
            clipDataArea.value = $dyn.value(messageForm.BrowserInteractionTimestamp) ? clipDataArea.value + $dyn.value(messageForm.BrowserInteractionTimestamp) + "\n" : clipDataArea.value;
            clipDataArea.value = $dyn.value(messageForm.AOSRoleInstance) ? clipDataArea.value + $dyn.value(messageForm.AOSRoleInstance) + "\n" : clipDataArea.value;
            clipDataArea.value = messageForm.buildInformation ? clipDataArea.value + messageForm.buildInformation + "\n" : clipDataArea.value;
            if ($dyn.value(messageForm.HasMultipleMessages)) {
                var numMessages = $dyn.length(messageForm.Messages);
                for (var i = 0; i < numMessages; i++) {
                    clipDataArea.value = clipDataArea.value + $dyn.value(messageForm.Messages()[i].Label) + "\n";
                }
            }
            if ($dyn.value(messageForm.SecondaryText)) {
                clipDataArea.value = clipDataArea.value + $dyn.value(messageForm.SecondaryText) + "\n";
            }
            document.body.appendChild(clipDataArea);
            clipDataArea.select();
            var copyPassed = $dyn.label("Copy_Failed");
            var copyError = "";
            try {
                var successful = document.execCommand("copy");
                copyPassed = $dyn.label("Copy_Passed");
            }
            catch (err) {
                copyError = err;
            }
            document.body.removeChild(clipDataArea);
            $dyn.superTooltip.tryOpenSuperTooltip(copyButton, copyPassed, copyError);
        }
        util.copyMessageDiagnosticsToClipBoard = copyMessageDiagnosticsToClipBoard;
        /**
         * Function to see if we are supporting zoom mode (url) and on flex
         * @returns true if supported and enabled
         */
        function isZoomSupported() {
            if ($dyn.layout.provider.name === $dyn.layout.Providers.css3flexbox) {
                return true;
            }
            return false;
        }
        util.isZoomSupported = isZoomSupported;
        /**
         * Function to see if we are activly on zoom view port we use to change layout
         * @returns true if in resolution
         */
        function isInZoomWidthMode() {
            if ($dyn.shell.CurrentShellViewPortWidthSize < $dyn.shell.ShellViewPortSizes.smallScreenSize) {
                return true;
            }
            return false;
        }
        util.isInZoomWidthMode = isInZoomWidthMode;
        /**
         * Function to see if we are activly on zoom view port we use to change layout
         * @returns true if in resolution
         */
        function isInZoomHeightMode() {
            if (Math.max(document.documentElement.clientHeight || 0) < $dyn.shell.ShellViewPortHeightSizes.smallScreenSize) {
                return true;
            }
            return false;
        }
        util.isInZoomHeightMode = isInZoomHeightMode;
    })(util = $dyn.util || ($dyn.util = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DynUtil.js.map
